import { createType } from '../../utils/helpers';
import { generateTypes } from '../../utils/HttpReducerHelper';

export const OPEN_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL = createType(
  'FUNDING_SEARCH',
  'OPEN_PRIVACY_TOGGLE_MODAL',
);
export const CLOSE_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL = createType(
  'FUNDING_SEARCH',
  'CLOSE_PRIVACY_TOGGLE_MODAL',
);

export const fundingSearchPrivacyToggle = generateTypes(
  'FUNDING_SEARCH',
  'FUNDING_SEARCH_PRIVACY_TOGGLE',
);
